import { getData, postData, postFormData } from './config/ApiCalls';

import { apiSettings } from '../Settings';

export const login = async (data) => {
  try {
    const response = await postData(`${apiSettings.auth.login}`, data);
    return response;
  } catch (error) {
    return null;
  }
};
export const verifyPassword = async (data) => {
  try {
    const response = await postData(`${apiSettings.auth.verifyPassword}`, data);
    return response;
  } catch (error) {
    return null;
  }
};
export const resetPassword = async (data) => {
  try {
    const response = await postData(`${apiSettings.auth.resetPassword}`, data);
    return response;
  } catch (error) {
    return null;
  }
};

export const register = async (data) => {
  try {
    const response = await postData(`${apiSettings.auth.register}`, data);
    return response;
  } catch (error) {
    return null;
  }
};

export const registerSupplier = async (data) => {
  try {
    const response = await postData(
      `${apiSettings.auth.registerSupplier}`,
      data
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const me = async () => {
  try {
    const response = await getData(`${apiSettings.auth.me}`);
    return response;
  } catch (error) {
    return null;
  }
};

export const forgotPassword = async (email = '') => {
  try {
    const response = await getData(`${apiSettings.auth.forgotPassword(email)}`);
    return response;
  } catch (error) {
    return null;
  }
};

export const getRoles = async () => {
  try {
    const response = await getData(`${apiSettings.auth.roles}`);
    return response;
  } catch (error) {
    return null;
  }
};
